import React from "react";
import PropTypes from "prop-types";
import { Button, Flex } from "orcs-design-system";
import styled from "styled-components";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useUserPerson } from "src/contexts/global/GlobalContext";

export const PromptButton = styled(Button)`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.surfaceBorder};
  color: ${(props) => props.theme.colors.bodyText};
  padding: 8px 26px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    background: ${(props) => props.theme.colors.hoverSurface};
    border-color: ${(props) => props.theme.colors.surfaceBorder};
  }
`;

/**
 * SuggestedPrompts component - displays suggested prompt buttons
 * @param {Object} props
 * @param {Function} props.onPromptSelect - Callback when a prompt is selected
 */
const SuggestedPrompts = ({ onPromptSelect }) => {
  const { enableAIDashboards } = useWorkspaceFeatureFlags();
  const person = useUserPerson();

  const suggestedPrompts = [];
  if (person) {
    if (person.memberOf?.length > 0) {
      suggestedPrompts.push("What are my team objectives?");
      suggestedPrompts.push(
        enableAIDashboards
          ? "Build a comprehensive dashboard of the teams I am in"
          : "Build a comprehensive overview of the team(s) I am in"
      );
    }
  }

  suggestedPrompts.push("How are we tracking against our Principles?");

  if (suggestedPrompts.length < 2) {
    suggestedPrompts.push("How many people do we have?");
  }

  return (
    <Flex flexDirection="column" alignItems="center" gap="r" mt="r">
      {/* Suggested Prompt Buttons */}
      <Flex flexWrap="wrap" justifyContent="center" gap="xs" maxWidth="500px">
        {suggestedPrompts.map((prompt) => (
          <PromptButton
            key={prompt}
            variant="ghost"
            onClick={() => onPromptSelect(prompt)}
            small
            mb="r"
          >
            {prompt}
          </PromptButton>
        ))}
      </Flex>
    </Flex>
  );
};

SuggestedPrompts.propTypes = {
  onPromptSelect: PropTypes.func.isRequired,
};

export default SuggestedPrompts;
